<template>
  <div class="info-section">
    <div class="info-section__header" v-if="$slots.header">
      <slot name="header"></slot>
      <hr>
    </div>
    <div class="info-section__content">
      <table class="info-section-table">
        <tr class="info-section-table__tr">
          <th
            v-for="(th, i) in fields"
            :key="i"
            class="info-section-table__th title"
          >
            {{th.title}}
          </th>
        </tr>
        <template
          v-for="(row, j) in showedList"
          class="info-section-table__tr"
        >
          <tr
            :key="j"
            class="info-section-table__tr">
            <td
              v-for="(column, i) in fields"
              :key="i"
              class="info-section-table__td">
              <div :title="filter(row, column)" class="info-section-table__item-wrap">
                <slot :name="`cell-${column.fieldName}`" :row="row" :column="column">
                  <span>{{filter(row, column)}}</span>
                </slot>
              </div>
            </td>
          </tr>
          <tr
            v-if="$scopedSlots['row-controls']"
            :key="`${j}-controls`"
          >
            <td :colspan="fields.length">
              <div class="info-section-table__row-controls">
                <slot name="row-controls" :row="row"></slot>
              </div>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
export default {
  name: 'InfoTable',
  mixins: [mixin],
  props: {
    data: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    showedList () {
      return this.data
    }
  }
}
</script>
<style lang="stylus">
  @import "./styles.styl"
  .info-section-table{
    table-layout fixed
    width 100%
    &__tr {
      text-align center
    }
    &__th {
      text-align center
    }
    &__td {
      text-align center
      text-overflow ellipsis
    }
    &__item-wrap{
      overflow hidden
      text-overflow ellipsis
    }
    &__row-controls {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      > * {
        margin: .5rem
      }
    }
  }
</style>
